import { render, staticRenderFns } from "./AddFirewallRule.vue?vue&type=template&id=6d5830d1&"
import script from "./AddFirewallRule.vue?vue&type=script&lang=js&"
export * from "./AddFirewallRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports